import _ from "lodash";
import React, { useState } from "react";
import EventRow from "../EventRow/EventRow";
import { TagOutlined } from "@toddle-edu/ds-icons";
import { SelectDropdown } from "@toddle-edu/ds-web";
import {
  setValue,
  mapStateToProps,
  mapActionCreators,
  getIsHolidayEventType,
} from "../../modules/Utils";
import { connect } from "react-redux";
import { useI18n } from "Hooks";
import { getFilteredEventTypes } from "MyCalendar/modules/Selector";
import { canUserCreateHolidaysAndWholeSchoolEvents } from "MyCalendar/modules/Utils";
import { INITIAL_PARTICIPANT_SELECTIONS } from "MyCalendar/modules/MyCalendarModule";
import classNames from "classnames";
import classes from "./EventType.scss";
import { getSelectedSchoolDetailsForCalendar } from "../../../../modules/Utils";

//2DTODO: Remove holiday and whole school event from dropdown for staff for creation and editing
const EventDropdownList = ({
  setSelectedEventType,
  eventType,
  errors,
  filteredEventTypeList,
  testId,
  showBorder,
  dropdownContainerClass = "",
}) => {
  const { t } = useI18n(["calendar"]);
  return (
    <div
      className={classNames(classes.eventTypeDropdown, dropdownContainerClass)}
    >
      <SelectDropdown
        name={"tag"}
        isSearchable={false}
        placeholder={t("calendar:select_the_event_type")}
        options={filteredEventTypeList}
        value={eventType}
        onChange={setSelectedEventType}
        isMulti={false}
        isClearable={false}
        size={"medium"}
        error={errors.tag}
        testId={`${testId}-eventTag`}
        variant={showBorder ? "outlined" : "plain"}
        classNamePrefix={"event-type-dropdown"}
      />
    </div>
  );
};

const getEventType = (eventTypeList, eventType) => {
  return _.find(eventTypeList, { value: eventType });
};
const EventType = props => {
  const {
    eventModalV2,
    updateEventModalV2,
    eventTypeList,
    dropdownContainerClass,
    showBorder = false,
  } = props;
  const setEventType = setValue("eventType", updateEventModalV2);
  const setEventUID = setValue("eventUID", updateEventModalV2);
  const setIsAllDayEvent = setValue("isAllDayEvent", updateEventModalV2);
  const setParticipants = setValue("participants", updateEventModalV2);
  const setEntityType = setValue("entityType", updateEventModalV2);
  const setIsRepeatEvent = setValue("isRepeatEvent", updateEventModalV2);
  const [selectedEventType, setSelectedEventType] = useState(
    getEventType(eventTypeList, eventModalV2?.eventType)
  );
  const eventTypeHandler = selectedOption => {
    setEventType(selectedOption?.value);
    const { uid } = selectedOption || {};
    if (getIsHolidayEventType(uid)) {
      setIsAllDayEvent(true);
      setIsRepeatEvent(false);
      // Resetting participants and entityType when event type changes
      if (eventModalV2?.entityType !== "GRADES") {
        setParticipants(INITIAL_PARTICIPANT_SELECTIONS);
      }
      setEntityType("");
    }
    setEventUID(uid);
    setSelectedEventType(selectedOption);
  };
  const errors = {};
  return (
    <EventRow
      label="schoolSetup:event_type"
      isRequired={true}
      icon={<TagOutlined variant="subtle" />}
      renderComponent={() => (
        <EventDropdownList
          setSelectedEventType={eventTypeHandler}
          eventType={selectedEventType}
          errors={errors}
          filteredEventTypeList={eventTypeList}
          testId="event-type-dropdown"
          dropdownContainerClass={dropdownContainerClass}
          showBorder={showBorder}
        />
      )}
    />
  );
};

const localMapStateToProps = state => {
  const tags = _.get(state, "myCalendar.schoolCalendarTags");
  const { currentCurriculumProgramId } = getSelectedSchoolDetailsForCalendar(
    state
  );
  const canCreateEventUsingAdminTag = canUserCreateHolidaysAndWholeSchoolEvents(
    {
      currentCurriculumProgramId,
    }
  );
  return {
    ...mapStateToProps(state),
    eventTypeList: getFilteredEventTypes({
      tags,
      canCreateEventUsingAdminTag,
    }),
  };
};

export default connect(localMapStateToProps, mapActionCreators)(EventType);
